import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { effect, inject } from '@angular/core';
import { Path } from '../constants';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  effect(() => {
    const isAuthenticated = authService.isAuthenticated();

    if (!isAuthenticated) {
      router.navigate([Path.LOGIN]);
    }
  });

  if (!authService.isAuthenticated()) {
    return false;
  } else {
    // Check if user is active (if user data is available)
    const currentUser = authService.currentUser();
    return currentUser ? true : false;
  }
};

export const notAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    router.navigate([Path.DASHBOARD]);
    return false;
  }
  return true;
};
